// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wave {
  margin-left: 0.5rem;
  animation-name: wave-animation; /* Refers to the name of your @keyframes element below */
  animation-duration: 2.5s; /* Change to speed up or slow down */
  animation-iteration-count: infinite; /* Never stop waving :) */
  transform-origin: 70% 70%; /* Pivot around the bottom-left palm */
  display: inline-block;
}

h2 {
  align-self: center;

  margin-top: 5rem;
  font-size: 5rem;
  color: rgb(34 211 238);
}
.aboutMeDescription {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  justify-content: center;

  max-width: 45rem;
}
.carouselContainer {
  margin-top: 7rem;
}

.aboutHeader {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-self: center;
  font-size: 5rem;
  margin-left: 2rem;
}

@keyframes wave-animation {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(14deg);
  } /* The following five values can be played with to make the waving more or less extreme */
  20% {
    transform: rotate(-8deg);
  }
  30% {
    transform: rotate(14deg);
  }
  40% {
    transform: rotate(-4deg);
  }
  50% {
    transform: rotate(10deg);
  }
  60% {
    transform: rotate(0deg);
  } /* Reset for the last half to pause */
  100% {
    transform: rotate(0deg);
  }
}

@media screen and (max-width: 767px) {
  .homeBox {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-content: center;
    justify-items: center;
    margin-top: -4rem;
  }

  .aboutMeDescription {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-content: center;
    justify-items: center;
    margin-left: 2.5rem;
    margin-top: 1rem;
    margin-right: 1rem;
    padding: 0;
    size: 80%;
  }

  h2 {
    margin-left: 0rem;
    align-self: center;
    margin-top: 2rem;
    font-size: 3rem;
  }

  .carouselContainer {
    width: 80%;
    margin-top: 2rem;
    padding-bottom: 3rem;
  }
  .aboutHeader {
    align-self: center;
    font-size: 3rem;
    margin: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/About.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,8BAA8B,EAAE,wDAAwD;EACxF,wBAAwB,EAAE,oCAAoC;EAC9D,mCAAmC,EAAE,yBAAyB;EAC9D,yBAAyB,EAAE,sCAAsC;EACjE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;;EAElB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;;EAEvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B,EAAE,yFAAyF;EAC3F;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB,EAAE,qCAAqC;EACvC;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,SAAS;EACX;AACF","sourcesContent":[".wave {\r\n  margin-left: 0.5rem;\r\n  animation-name: wave-animation; /* Refers to the name of your @keyframes element below */\r\n  animation-duration: 2.5s; /* Change to speed up or slow down */\r\n  animation-iteration-count: infinite; /* Never stop waving :) */\r\n  transform-origin: 70% 70%; /* Pivot around the bottom-left palm */\r\n  display: inline-block;\r\n}\r\n\r\nh2 {\r\n  align-self: center;\r\n\r\n  margin-top: 5rem;\r\n  font-size: 5rem;\r\n  color: rgb(34 211 238);\r\n}\r\n.aboutMeDescription {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  align-self: center;\r\n  justify-content: center;\r\n\r\n  max-width: 45rem;\r\n}\r\n.carouselContainer {\r\n  margin-top: 7rem;\r\n}\r\n\r\n.aboutHeader {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: center;\r\n  align-self: center;\r\n  font-size: 5rem;\r\n  margin-left: 2rem;\r\n}\r\n\r\n@keyframes wave-animation {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  10% {\r\n    transform: rotate(14deg);\r\n  } /* The following five values can be played with to make the waving more or less extreme */\r\n  20% {\r\n    transform: rotate(-8deg);\r\n  }\r\n  30% {\r\n    transform: rotate(14deg);\r\n  }\r\n  40% {\r\n    transform: rotate(-4deg);\r\n  }\r\n  50% {\r\n    transform: rotate(10deg);\r\n  }\r\n  60% {\r\n    transform: rotate(0deg);\r\n  } /* Reset for the last half to pause */\r\n  100% {\r\n    transform: rotate(0deg);\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .homeBox {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    align-content: center;\r\n    justify-items: center;\r\n    margin-top: -4rem;\r\n  }\r\n\r\n  .aboutMeDescription {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    align-content: center;\r\n    justify-items: center;\r\n    margin-left: 2.5rem;\r\n    margin-top: 1rem;\r\n    margin-right: 1rem;\r\n    padding: 0;\r\n    size: 80%;\r\n  }\r\n\r\n  h2 {\r\n    margin-left: 0rem;\r\n    align-self: center;\r\n    margin-top: 2rem;\r\n    font-size: 3rem;\r\n  }\r\n\r\n  .carouselContainer {\r\n    width: 80%;\r\n    margin-top: 2rem;\r\n    padding-bottom: 3rem;\r\n  }\r\n  .aboutHeader {\r\n    align-self: center;\r\n    font-size: 3rem;\r\n    margin: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
